import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import Subscriptions from "./subscriptions";
import Notifications from "./notifications";
import Authentication from "./authentication";
import Preferences from "./preferences";
import Header from "../../header";
import Navvbar from "../../Navvbar";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const User = () => {
  const [state, setState] = useState({
    salutation: "",
    first_name: "",
    middleInitial: "",
    last_name: "",
    email: "",
    labEmail: "",
    labName: "",
    address: "",
    address2: "",
    city: "",
    state: "",
    country: "",
    zipCode: "",
    telephone: "",
    timeZone: "UTC",
    subdomain: "",
    services: [],
    newsletter: false,
    trainingInterest: false,
    emailNotifications: {},
    webNotifications: {},
    authentication: {
      userName: "",
      confirmUserName: "",
      noEmail: false,
      password: "",
      confirmPassword: "",
    },
    preferences: {
      teethNotation: "Universal",
      language: "English (US)",
      technicianStamp: "",
      disableRxTyping: false,
    },
  });

  const [error, setError] = useState(null);
  const navigate = useNavigate();

  const fetchUserData = async () => {
    try {
      const userId = localStorage.getItem("userId");

      if (!userId) {
        throw new Error("User ID not found in local storage");
      }

      const response = await axios.get(
        `https://hms.backend.hiragroupcloud.com/api/auth/users/${userId}`
      );

      if (response.data.success) {
        setState((prev) => ({
          ...prev,
          ...response.data.user,
          emailNotifications: response.data.user.emailNotifications || {},
          webNotifications: response.data.user.webNotifications || {},
          authentication: {
            userName: response.data.user.email || "",
            confirmUserName: response.data.user.email || "",
            noEmail: false,
            password: "",
            confirmPassword: "",
          },
          preferences: {
            teethNotation: response.data.user.preferences?.teethNotation || "Universal",
            language: response.data.user.preferences?.language || "English (US)",
            technicianStamp: response.data.user.preferences?.technicianStamp || "",
            disableRxTyping: response.data.user.preferences?.disableRxTyping || false,
          },
        }));
      } else {
        throw new Error(response.data.message || "Failed to fetch user data");
      }
    } catch (err) {
      console.error("Failed to fetch user data:", err);
      setError(err.response?.data?.message || err.message || "Failed to fetch user data");
      toast.error(err.response?.data?.message || "Failed to fetch user data", {
        position: "top-center",
        autoClose: 3000,
        closeButton: true,
      });
    }
  };

  useEffect(() => {
    fetchUserData();
  }, [navigate]);

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setState((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleNestedChange = (section, field, value) => {
    setState((prev) => ({
      ...prev,
      [section]: {
        ...prev[section],
        [field]: value,
      },
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const userId = localStorage.getItem("userId");

      if (!userId) {
        throw new Error("User ID not found in local storage");
      }

      const toastId = toast.loading("Updating profile...", {
        position: "top-center",
      });

      const response = await axios.put(
        `https://hms.backend.hiragroupcloud.com/api/auth/${userId}`,
        state
      );

      if (response.data.success) {
        toast.update(toastId, {
          render: "Profile updated successfully!",
          type: "success",
          isLoading: false,
          position: "top-center",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          closeButton: true,
        });
        setState((prev) => ({
          ...prev,
          ...response.data.user,
          authentication: {
            ...prev.authentication,
            password: "",
            confirmPassword: "",
          },
        }));
      } else {
        toast.dismiss(toastId);
        throw new Error(response.data.message || "Failed to update profile");
      }
    } catch (err) {
      console.error("Failed to update user:", err);
      toast.error(err.response?.data?.message || "Failed to update profile", {
        position: "top-center",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        closeButton: true,
      });
    }
  };

  const updateUserData = async (updatedData) => {
    try {
      const userId = localStorage.getItem("userId");

      if (!userId) {
        throw new Error("User ID not found in local storage");
      }

      const toastId = toast.loading("Updating user data...", {
        position: "top-center",
      });

      const response = await axios.put(
        `https://hms.backend.hiragroupcloud.com/api/auth/${userId}`,
        updatedData
      );

      if (response.data.success) {
        toast.update(toastId, {
          render: "User data updated successfully!",
          type: "success",
          isLoading: false,
          position: "top-center",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          closeButton: true,
        });
        setState((prev) => ({
          ...prev,
          ...response.data.user,
          authentication: {
            ...prev.authentication,
            password: "",
            confirmPassword: "",
          },
        }));
        return true;
      } else {
        toast.dismiss(toastId);
        throw new Error(response.data.message || "Failed to update user data");
      }
    } catch (err) {
      console.error("Failed to update user:", err);
      toast.error(err.response?.data?.message || "Failed to update user data", {
        position: "top-center",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        closeButton: true,
      });
      return false;
    }
  };

  if (error) {
    return (
      <div>
        <Header />
        <Navvbar />
        <div className="text-center mt-5 text-danger">Error: {error}</div>
      </div>
    );
  }

  return (
    <div>
      <ToastContainer
        position="top-center"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
      <Header />
      <Navvbar />
      <br />
      <br />
      <div style={{ width: "95%", margin: "0 auto", padding: "0px" }}>
        <div className="row">
          <div
            className="col-md-2"
            style={{ borderRight: "1px solid #004aad" }}
          >
            <div>
              <h2 style={{ marginLeft: "10px" }}>Settings</h2>
              <div>
                <div style={{ columnCount: 1 }}>
                  <Link
                    to="/Tabs"
                    style={{
                      textDecoration: "none",
                      fontSize: "17px",
                      color: "#004aad",
                      marginLeft: "12px",
                    }}
                  >
                    Lab Details
                  </Link>
                </div>
                <div style={{ columnCount: 1 }}>
                  <Link
                    to="/"
                    style={{
                      textDecoration: "none",
                      fontSize: "17px",
                      color: "#004aad",
                      marginLeft: "13px",
                    }}
                  >
                    Store
                  </Link>
                </div>
                <div style={{ columnCount: 1 }}>
                  <Link
                    to="/usersetting"
                    style={{
                      textDecoration: "none",
                      fontSize: "17px",
                      color: "#004aad",
                      marginLeft: "12px",
                    }}
                  >
                    Users
                  </Link>
                </div>
                <div style={{ columnCount: 1 }}>
                  <Link
                    to="/"
                    style={{
                      textDecoration: "none",
                      fontSize: "17px",
                      color: "#004aad",
                      marginLeft: "12px",
                    }}
                  >
                    Permission Groups
                  </Link>
                </div>
                <div style={{ columnCount: 1 }}>
                  <Link
                    to="/Account"
                    style={{
                      textDecoration: "none",
                      fontSize: "17px",
                      color: "#004aad",
                      marginLeft: "12px",
                    }}
                  >
                    Accounts
                  </Link>
                </div>
                <div style={{ columnCount: 1 }}>
                  <Link
                    to="/Owerviews"
                    style={{
                      textDecoration: "none",
                      fontSize: "17px",
                      color: "#004aad",
                      marginLeft: "12px",
                    }}
                  >
                    Finances
                  </Link>
                </div>
                <div style={{ columnCount: 1 }}>
                  <Link
                    to="/owersetting"
                    style={{
                      textDecoration: "none",
                      fontSize: "17px",
                      color: "#004aad",
                      marginLeft: "12px",
                    }}
                  >
                    Case Settings
                  </Link>
                </div>
              </div>
            </div>
          </div>

          <div className="col-md-10">
            <h1 style={{ marginBottom: "10px" }}>Edit User</h1>
            <h3
              className="title"
              style={{ marginBottom: "20px", color: "black" }}
            >
              User
            </h3>
            <form onSubmit={handleSubmit}>
              <div
                style={{
                  border: "1px solid #f8f9fa",
                  borderTop: "3px solid blue",
                  backgroundColor: "#f8f9fa",
                }}
              >
                <div
                  style={{
                    marginTop: "20px",
                    marginBottom: "10px",
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                >
                  <label
                    style={{ fontWeight: "bold", marginLeft: "15px" }}
                    data-bs-toggle="tooltip"
                    title="Salutation"
                  >
                    Salutation:
                  </label>
                  <input
                    type="text"
                    name="salutation"
                    value={state.salutation || ""}
                    onChange={handleInputChange}
                    style={{
                      marginRight: "40%",
                      padding: "8px",
                      borderRadius: "4px",
                      border: "1px solid #ccc",
                      width: "30%",
                    }}
                  />
                </div>
                <div
                  style={{
                    marginBottom: "10px",
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                >
                  <label style={{ fontWeight: "bold", marginLeft: "15px" }}>
                    First Name:
                  </label>
                  <input
                    type="text"
                    name="first_name"
                    value={state.first_name || ""}
                    onChange={handleInputChange}
                    style={{
                      marginRight: "40%",
                      padding: "8px",
                      borderRadius: "4px",
                      border: "1px solid #ccc",
                      width: "30%",
                    }}
                    required
                  />
                </div>
                <div
                  style={{
                    marginBottom: "10px",
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                >
                  <label style={{ fontWeight: "bold", marginLeft: "15px" }}>
                    Middle Initial:
                  </label>
                  <input
                    type="text"
                    name="middleInitial"
                    value={state.middleInitial || ""}
                    onChange={handleInputChange}
                    style={{
                      marginRight: "40%",
                      padding: "8px",
                      borderRadius: "4px",
                      border: "1px solid #ccc",
                      width: "30%",
                    }}
                  />
                </div>
                <div
                  style={{
                    marginBottom: "10px",
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                >
                  <label style={{ fontWeight: "bold", marginLeft: "15px" }}>
                    Last Name:
                  </label>
                  <input
                    type="text"
                    name="last_name"
                    value={state.last_name || ""}
                    onChange={handleInputChange}
                    style={{
                      marginRight: "40%",
                      padding: "8px",
                      borderRadius: "4px",
                      border: "1px solid #ccc",
                      width: "30%",
                    }}
                    required
                  />
                </div>
                <div
                  style={{
                    marginBottom: "20px",
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                >
                  <label style={{ fontWeight: "bold", marginLeft: "15px" }}>
                    External ID:
                  </label>
                  <input
                    type="text"
                    name="userId"
                    value={state.userId || ""}
                    onChange={handleInputChange}
                    disabled
                    style={{
                      marginRight: "40%",
                      padding: "8px",
                      borderRadius: "4px",
                      border: "1px solid #ccc",
                      width: "30%",
                      backgroundColor: "#e9ecef",
                    }}
                  />
                </div>
              </div>
              <div className="mt-3" style={{ textAlign: "right" }}>
                <button
                  type="submit"
                  className="btn btn-primary"
                  style={{ marginRight: "20px" }}
                >
                  Save Changes
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div style={{ borderRight: "2px solid #004aad" }}>
        <div className="mt-3">
          <Authentication
            userData={state}
            onUpdate={updateUserData}
            onFieldChange={handleNestedChange}
          />
        </div>
        <div className="mt-3">
          <Subscriptions
            userData={state}
            onUpdate={updateUserData}
            onFieldChange={handleNestedChange}
          />
        </div>
        <div className="mt-3">
          <Notifications
            userData={state}
            onUpdate={updateUserData}
            onFieldChange={handleNestedChange}
          />
        </div>
        <div className="mt-3">
          <Preferences
            userData={state}
            onUpdate={updateUserData}
            onFieldChange={handleNestedChange}
          />
        </div>
        <br />
      </div>
    </div>
  );
};

export default User;